/*
 * @Author: wq
 * @Date: 2020-07-14 15:53:35
 */

const proApi = {
  /**
   * 廉餐-公用接口
   */
  getPolicyAndLawsList: "api/service/rabbit-regulations/policiesRegulations/allList", // 所有食安政策法规列表
  getPolicyAndLawsDetail: "api/service/rabbit-regulations/policiesRegulations/details", // 食安政策法规详情
  getServiceInformationList: "api/service/rabbit-liancan/serviceInformation/listForWeb", // 服务指南列表
  getServiceInformationDetail: "api/service/rabbit-liancan/serviceInformation/detailForWeb", // 服务指南详情
  postSupplierAccount: "api/service/rabbit-resource/sms/endpoint/send-validate", // 供应商/学校验证码接口
  postValidateCode: "api/service/rabbit-resource/sms/endpoint/validate-message", // 验证是否有效
  getProvince: "api/service/rabbit-system/region/getProvince", // 获取省份
  getCity: "api/service/rabbit-system/region/getCity/", // 根据省份ID获取市
  getArea: "api/service/rabbit-system/region/getArea/", // 根据市区ID获取区
  getBiddingPurchaseType: 'api/service/rabbit-backendBidding/biddingPurchaseType/dict', // 招标类别
  postFile: 'api/service/rabbit-resource/oss/endpoint/upload-file', // 上传文件接口

  /**
   * 廉餐-首页
   */
  getSystemNotice: "api/service/rabbit-liancan/websiteNotice/list", // 首页系统公告/共系统公告列表
  getSystemNoticeDetail: "api/service/rabbit-liancan/systemNotice/detail", // 系统公告详情
  getPolicyList: "api/service/rabbit-regulations/policiesRegulations/policyList", // 首页食安政策列表
  getStatuteList: "api/service/rabbit-regulations/policiesRegulations/statuteList", // 首页食安法规列表
  getBiddingNoticeForWeb: "api/service/rabbit-backendBidding/bidding/home/biddingNoticeForWeb", // 首页采购需求
  getNewBiddingList: "api/service/rabbit-backendBidding/bidding/newBiddingList", // 首页成交公告
  getLiancanBannerList: "api/service/rabbit-web2/banner/getLiancanBannerList", // 获取首页顶部轮播图、底部链接、上边条幅、下边条幅列表
  getRelationFilePage: "api/service/rabbit-web2/notice/getRelationFilePage", // 获取首页左侧视频、焦点新闻分页列表
  getNewNoticePage: "api/service/rabbit-web2/notice/getNewNoticePage", // 获取最新食堂公开 4X列表
  getIllegalTypeList: "api/service/rabbit-web2/illegalWarn/getIllegalTypeList", // 获取违规类型字典列表(未分类)
  getIllegalSettingList: "api/service/rabbit-web2/illegalWarn/getIllegalSettingList", // 获取违规类型字典列表(分五类)
  getMonthDataForYearList: "api/service/rabbit-web2/illegalWarn/getMonthDataForYearList", // 获取柱状图数据(1-12月)

  /**
   * 廉餐-供应商入驻
   */
  postSupplierRegister: "api/service/rabbit-supplier/supplierAccount/register", // 供应商注册接口
  getLicenseUpload: "api/service/rabbit-supplier/supplierAccount/upload", // 上传营业执照/识别接口

  /**
   * 廉餐-单位入驻
   */
  postSchoolSigninInfo: "api/service/rabbit-liancan/schoolSigninInfo/register", // 学校注册接口
  getSchoolIsRegister: "api/service/rabbit-liancan/schoolSigninInfo/isRegister", // 学校-通过手机号判断是否注册成功
  getDictionaryType: "api/service/rabbit-system/dict/dictionary?code=school_type", // 获取学校类型
  getSchoolOwnershipType: "api/service/rabbit-system/dict/dictionary?code=school_ownership", // 获取学校所有制类型(公办/民办)

  /**
   * 采购需求/日历
   */
  getHaveDataDay: "api/service/rabbit-backendBidding/bidding/getDay", // 日历-月份内有数据的day
  getDayBiddingList: "api/service/rabbit-backendBidding/bidding/getByDay", // 获取某天的招标信息列表

  /**
   * 成交公告
   */
  getShufflingFigure: "api/service/rabbit-backendBidding/bidding/shufflingFigure", // 中标轮播图详情信息
  getBiddingNoticList: "api/service/rabbit-backendBidding/bidding/home/noticList", // 首页成交公告列表

  /**
   * 采购需求
   */
  getZhaoList: "api/service/rabbit-backendBidding/bidding/home/biddingNoticeList",
  getZhaoDetail: "api/service/rabbit-backendBidding/bidding/home/detail",

  /**
   * 违规预警
   */
  getMonthDataForTypeList: "api/service/rabbit-web2/illegalWarn/getMonthDataForTypeList", // 获取饼状图/环图数据
  getAllWarningList: 'api/service/rabbit-liancan/illegalWarnLog/allWarningList',

  /**
   * 光盘行动
   */
  getKitchenWastePage: "api/service/rabbit-web2/cdAction/getKitchenWastePage", // 获取厨废数据分页列表
  getSchoolTypeList: "api/service/rabbit-web2/cdAction/getSchoolTypeList", // 获取学校类型列表

  /**
   * 食堂公开
   */
  // getOpenDiningHall: "api/service/rabbit-liancan/schoolAuthInfo/info/list", // 食堂公开首页
  getOpenDiningHall: "api/service/rabbit-web2/canteenOpen/getCanteenPage", // 食堂公开首页 2021/7/31
  getOpenFinancing: "api/service/rabbit-income/income/financeOpen", // 财务公开
  // getOpenProcurement: "api/service/rabbit-web2/notice/getCggkNoticePage", // 采购公开列表 v1.1.1
  getdiningPublic: "api/service/rabbit-liancan/order/diningPublic", //食堂公开
  getPurchasingDemand: 'api/service/rabbit-web2/canteenOpen/getPurchasingDemand', // 获取采购需求列表
  getTransactionAnnouncement: 'api/service/rabbit-web2/canteenOpen/getTransactionAnnouncement', // 获取成交公告列表
  getOpenMealPriceList: 'api/service/rabbit-web2/canteenOpen/getOpenMealPriceList', // 获取食堂餐价公开列表（统缴餐）
  getFoodInformationPage: 'api/service/rabbit-web2/canteenOpen/getFoodInformationPage', // 获取餐价公开列表（自选餐）
  getUnit: '/api/service/rabbit-system/dict/dictionary', //获取计量单位
  getOrderDetail: "api/service/rabbit-web2/notice/getOrder", // 采购公开详情v1.1.1
  getLiancanNotice: "api/service/rabbit-web2/notice/getLiancanNotice", // 获取文章详情v1.1.1
  // 获取文章列表 分页v1.1.1 type类型（(0-采购公开的数据不从这里拿) 1-餐价公开，2-检测公开，3-财务公开，4-光盘行动，5-风险食材，6-曝光台，7-下载中心）
  getLiancanNoticePage: "api/service/rabbit-web2/notice/getLiancanNoticePage",

  /**
  * 服务中心
  */
  getServerDetail: "api/service/rabbit-liancan2/notice/serviceCenter/detail",  //服务中心数据
  /**
   * 投诉监督
   */
  getSuggestionPage: "api/service/rabbit-web2/suggestion/getSuggestionPage" // 获取投诉监督分页列表v1.1.1
};
export { proApi };



// WEBPACK FOOTER //
// ./src/assets/api/api.js